import Axios from "../helper/appConfig";

export const getBranchDataService = async (name) => {
  let payload = {
    viewname: "bookingwebsiteviews",
    search: [
      {
        searchfield: "shortname",
        searchvalue: name ? name :  "spinnakeratlakedillon",
        criteria: "eq",
        datatype: "text",
      },
    ],
  };
  return Axios.post(`api/formdatas/filter`, payload);
};
